<div class="container-box">
  <!-- input fields -->
  <div class="filters-box">
    <app-rental-select
      matTooltip="Only show channel connections that specify the selected rentals."
      matTooltipPosition="above"
      i18n-matTooltip
      [items]="connectionFilters.rentals$ | asyncSchedule | async"
      [ctrl]="filters.get('rentals')"
      placeholder="Rentals"
      i18n-placeholder
      [inline]="true"
      *ngIf="!defaultRental"
    ></app-rental-select>
    <app-select-search
      matTooltip="Only show channel connections that specify the selected channels."
      matTooltipPosition="above"
      i18n-matTooltip
      [items]="connectionFilters.channels$ | async"
      [ctrl]="filters.get('channels')"
      placeholder="Channels"
      i18n-placeholder
    ></app-select-search>
    <mat-form-field2
      matTooltip="Only show channel connections that specify the selected type."
      matTooltipPosition="above"
      i18n-matTooltip
      [showLabel]="false"
    >
      <mat-select [formControl]="filters.get('type')" placeholder="Type" i18n-placeholder>
        <mat-option value="all" i18n>All Types</mat-option>
        <mat-option i18n [value]="typeTexts.API" [disabled]="channelTypeCtrl.value === 'ical'"> API </mat-option>
        <mat-option i18n [value]="typeTexts.Exported" [disabled]="channelTypeCtrl.value === 'api'">
          Exported iCal
        </mat-option>
        <mat-option i18n [value]="typeTexts.Imported" [disabled]="channelTypeCtrl.value === 'api'">
          Imported iCal
        </mat-option>
      </mat-select>
    </mat-form-field2>
    <mat-form-field2
      matTooltip="Only show channel connections that specify the selected status."
      matTooltipPosition="above"
      i18n-matTooltip
      [showLabel]="false"
    >
      <mat-select [formControl]="filters.get('status')" placeholder="Status" i18n-placeholder>
        <mat-option value="all" i18n>All Status</mat-option>
        <mat-option [value]="statusTexts.Active" i18n>Active</mat-option>
        <mat-option [value]="statusTexts.Disabled" i18n>Disabled</mat-option>
        <mat-option [value]="statusTexts.Disconnected" i18n>Disconnected</mat-option>
        <mat-option [value]="statusTexts.Inactive" i18n>Inactive</mat-option>
        <mat-option [value]="statusTexts.Unlisted" i18n>Unlisted</mat-option>
        <mat-option [value]="statusTexts.Deleted" i18n>Deleted</mat-option>
        <mat-option [value]="statusTexts.Pending" i18n>Pending</mat-option>
        <mat-option [value]="statusTexts.Stale" i18n>Stale</mat-option>
      </mat-select>
    </mat-form-field2>
    <mat-form-field2
      matTooltip="Only show channel connections that specify the selected linkage type."
      matTooltipPosition="above"
      i18n-matTooltip
      [showLabel]="false"
    >
      <mat-select [formControl]="filters.get('linkage')" placeholder="Linkage" i18n-placeholder>
        <mat-option value="all" i18n>All Connections</mat-option>
        <mat-option value="linked" i18n>Linked Connections</mat-option>
        <mat-option value="unlinked" i18n>Unlinked Connections</mat-option>
      </mat-select>
    </mat-form-field2>
    <app-cancel-filters
      [isFiltering]="filters | isFiltering"
      [filterControl]="filters"
      [ignoreFields]="defaultRental ? ['rentals'] : ['channelType']"
      [searchCom]="searchCom"
    ></app-cancel-filters>
    <button
      (click)="onRefresh()"
      class="btn btn-secondary-primary"
      type="button"
      matTooltip="Refresh"
      matTooltipPosition="above"
      i18n-matTooltip
    >
      <i class="far fa-sync"></i>
    </button>
    <div class="flex-fill"></div>
    <app-table-search (search)="onSearch($event)" [filterGroup]="filterGroup" #searchCom></app-table-search>
  </div>

  <div class="table-holder table-responsive">
    <table class="table table-default table-striped">
      <mat-table #table matSort matSortActive="warning" matSortDirection="desc" [dataSource]="dataSource">
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              [checked]="selection.hasValue() && isAllSelected(isSelectAllRenderedItems)"
              [indeterminate]="selection.hasValue() && !isAllSelected(isSelectAllRenderedItems)"
              (change)="onMasterToggle($event?.checked)"
              class="master-toggle"
            >
            </mat-checkbox>
            <div
              class="btn-group master-toggle-group clickable"
              dropdown
              container="body"
              [isDisabled]="!dataSource.data?.length"
            >
              <div dropdownToggle>
                <i class="fa fa-caret-down ml-2"></i>
              </div>
              <ul class="dropdown-menu" *dropdownMenu>
                <li>
                  <button type="button" (click)="onSelectAll(true)" i18n>All</button>
                </li>
                <li>
                  <button type="button" (click)="onSelectAll(false)" i18n>All Visible</button>
                </li>
                <li>
                  <button type="button" (click)="onMasterToggle(false)" i18n>None</button>
                </li>
              </ul>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(element) : null"
              [checked]="selection.isSelected(element)"
              *ngIf="!element.isFeedApi"
            >
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="channelFriendlyName">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Channel</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="text-truncate" [matTooltip]="element.icalSourceView || element.channelFriendlyName">
              {{ element.icalSourceView || element.channelFriendlyName }}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="typeText">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Type</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.typeText }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="linkDateOrCreated">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Date Linked</mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            [matTooltip]="element.linkDateOrCreated | epoch : 'DD - MMM - YYYY h:mm:ss A'"
            matTooltipPosition="above"
          >
            {{ element.linkDateOrCreatedView }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="rentalName">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Linked Rental</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [matTooltip]="element.rentalName" matTooltipPosition="above">
              {{ element.rentalName || '....' | truncate : 25 }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="propertyNameView">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Property Name</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [matTooltip]="element.propertyNameView" matTooltipPosition="above" class="text-truncate">
              {{ element.propertyNameView }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="statusText">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> status</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [matTooltip]="getStatusTooltip(element)" matTooltipPosition="above">
              {{ element.statusText }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef>
            <app-table-column-manager
              tableId="connections"
              [displayedColumns]="displayedColumns"
              (columnsChanged)="displayedColumns = $event"
            ></app-table-column-manager>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div dropdown placement="bottom right" container="body">
              <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
                <a class="btn-ellips">
                  <i class="fas fa-ellipsis-v"></i>
                </a>
              </div>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li>
                  <button type="button" (click)="onConnectionDetail(element, false)">
                    <i class="cs-icon cs-icon-pencil"></i> <ng-container i18n>Connection Detail</ng-container>
                  </button>
                </li>
                <ng-container *ngIf="!(1 | isReadonlyRole)">
                  <li *ngIf="element.needsReconnect">
                    <button type="button" (click)="onReconnect(element)">
                      <i class="fal fa-plug"></i> <ng-container i18n>Reconnect</ng-container>
                    </button>
                  </li>
                  <li>
                    <button (click)="onChannelDetails(element.channel)" type="button">
                      <i class="fal fa-share-alt-square"></i><ng-container i18n>Channel Detail</ng-container>
                    </button>
                  </li>
                  <li *ngIf="!defaultRental && element.rental">
                    <button type="button" (click)="onRentalDetails(element.rental)">
                      <i class="fal fa-home"></i> <ng-container i18n>Rental Detail</ng-container>
                    </button>
                  </li>
                  <li *ngIf="element.isApi && !element.rentalId && !element.roomMissing">
                    <button type="button" (click)="onLinkRental(element)" [disabled]="element.isPlaceholderRoom">
                      <i class="fal fa-link"></i> <ng-container i18n>Link</ng-container>
                    </button>
                  </li>
                  <li *ngIf="!defaultRental && hasWizard(element)">
                    <button type="button" (click)="onOpenWizard(element)">
                      <i class="fal fa-life-ring"></i> <ng-container i18n>Connection Wizard</ng-container>
                    </button>
                  </li>
                  <li *ngIf="element.isApi && element.rentalId && !(isFeed | call : element)">
                    <button type="button" (click)="onUnlinkRental(element)">
                      <i class="fal fa-unlink"></i> <ng-container i18n>Unlink</ng-container>
                    </button>
                  </li>
                  <li *ngIf="!element.isApi">
                    <button (click)="onRemove(element)" type="button">
                      <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                    </button>
                  </li>
                </ng-container>
              </ul>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="onConnectionDetail(row)"
          [class.row-danger]="row.warning"
          class="clickable"
        ></mat-row>
      </mat-table>

      <mat-paginator2
        #paginator
        [length]="dataSource?.data?.length"
        [class.hidden]="isEmptyTable$ | async"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
        [showFirstLastButtons]="true"
      >
      </mat-paginator2>

      <app-empty-table
        *ngIf="isEmptyTable$ | async"
        [isFiltering]="(filters | isFiltering) || !searchCom.isEmpty"
        [type]="tableType"
      ></app-empty-table>
    </table>
  </div>
</div>
